import { render, staticRenderFns } from "./CardItemScaffoldGroups.vue?vue&type=template&id=3d6bdc84"
import script from "./CardItemScaffoldGroups.vue?vue&type=script&lang=ts"
export * from "./CardItemScaffoldGroups.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d6bdc84')) {
      api.createRecord('3d6bdc84', component.options)
    } else {
      api.reload('3d6bdc84', component.options)
    }
    module.hot.accept("./CardItemScaffoldGroups.vue?vue&type=template&id=3d6bdc84", function () {
      api.rerender('3d6bdc84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/cards/CardItemScaffoldGroups.vue"
export default component.exports